var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapMarkerRequisitionDeliveryCancelled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "52px",
    viewBox: "0 0 30 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "map-marker-requisition-delivery-cancelled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Map-Marker-/-Requisition-Delivery-Completed-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0776014,3.18323146e-11 C17.6439349,3.18323146e-11 18.1253184,0.198216735 18.5217519,0.594650206 C18.9181854,0.991083676 19.1164021,1.47246718 19.1164021,2.03880071 L19.1164021,2.03880071 L19.1164021,7.02880658 L21.9512052,7.02880658 C22.8573388,7.02880658 23.4803057,7.45355673 23.8201058,8.30305703 C24.1599059,9.15255732 24.0183226,9.88879091 23.3953557,10.5117578 L23.3953557,10.5117578 L20.7725754,13.1343218 C26.1914561,15.3628767 30,20.6344221 30,26.7826087 C30,32.2254149 25,40.631212 15,52 C5,40.631212 5.45696821e-12,32.2254149 5.45696821e-12,26.7826087 C5.45696821e-12,20.6344221 3.80854391,15.3628767 9.22742459,13.1343218 L6.60464433,10.5117578 C5.98167744,9.88879091 5.84009406,9.15255732 6.17989418,8.30305703 C6.5196943,7.45355673 7.14266118,7.02880658 8.04879483,7.02880658 L8.04879483,7.02880658 L10.8835979,7.02880658 L10.8835979,2.03880071 C10.8835979,1.47246718 11.0818146,0.991083676 11.4782481,0.594650206 C11.8746816,0.198216735 12.3560651,3.18323146e-11 12.9223986,3.18323146e-11 L12.9223986,3.18323146e-11 Z",
    id: "Combined-Shape",
    fill: "#E02020"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#1F5BC0",
    cx: 15,
    cy: 27,
    r: 11
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerRequisitionDeliveryCancelled);
export default __webpack_public_path__ + "static/media/map-marker-requisition-delivery-cancelled.16f1c3661fa586d5a9aadbe598945a9b.svg";
export { ForwardRef as ReactComponent };